export default __webpack_public_path__ + "static/media/checkbox.71ed5dcf.svg";